import { Directive, ElementRef, HostListener, inject, Input } from '@angular/core';

@Directive({
  selector: '[cslInputPattern]',
  standalone: true,
})
export class InputPatternDirective {
  private inputElement = inject(ElementRef).nativeElement as HTMLInputElement;

  private _pattern!: RegExp;
  @Input({ alias: 'cslInputPattern', required: true })
  public get pattern(): RegExp {
    return this._pattern;
  }
  public set pattern(value: RegExp | string) {
    this._pattern = new RegExp(value);
  }

  private allowedKeys: string[] = [
    'Backspace',
    'Delete',
    'ArrowLeft',
    'ArrowRight',
    'Tab',
    'Enter',
    'Home',
    'End',
    'Control',
    'Meta',
    'Shift',
  ];

  @HostListener('keydown', ['$event']) onKeyDown(event: KeyboardEvent): void {
    const inputChar = event.key;

    if (this.allowedKeys.includes(inputChar) || event.ctrlKey || event.metaKey) {
      return;
    }

    const newValue = this.getNewValue(inputChar);

    if (!this.pattern.test(newValue)) {
      event.preventDefault();
    }
  }

  @HostListener('paste', ['$event']) onPaste(event: ClipboardEvent): void {
    const clipboardData = event.clipboardData;
    if (clipboardData) {
      const pastedInput = clipboardData.getData('text');
      const newValue = this.getNewValue(pastedInput);

      if (!this.pattern.test(newValue)) {
        event.preventDefault();
      }
    }
  }

  private getNewValue(input: string): string {
    const currentValue = this.inputElement.value;
    const selectionStart = this.inputElement.selectionStart ?? 0;
    const selectionEnd = this.inputElement.selectionEnd ?? 0;

    return currentValue.slice(0, selectionStart) + input + currentValue.slice(selectionEnd);
  }
}
